import { render, staticRenderFns } from "./ProjectContentDisplay.vue?vue&type=template&id=f46d6288&scoped=true"
import script from "./ProjectContentDisplay.vue?vue&type=script&lang=js"
export * from "./ProjectContentDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProjectContentDisplay.vue?vue&type=style&index=0&id=f46d6288&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d6288",
  null
  
)

export default component.exports